<template>
  <div>
    <div
      class="row workstation-list"
      :class="!isUserThalesAdmin() ? 'large-screen' : ''"
      :style="sizeWorkstationList(stationsList)"
    >
      <div
        v-for="(station, index) in stationsList"
        :key="index"
        class=" mx-2 col-8 col-sm-6 col-lg-3 col-xl"
      >
        <div @click="showStationModal(station)" class="clickable">
          <div class="workstation-header">
            LT {{ computeLeadTime(station) }}
          </div>
          <div
            class="workstation-card"
            :class="
              station.kanbanCards.length > parseInt(station.nbKanbanMax, 10)
                ? 'andon .text-white'
                : ''
            "
            :style=" sizeWorkstationCard(stationsList)"
          >
            <div
              v-if="isUserThalesAdmin()"
              class="workstation-edit-icon"
              :style="stationsList.length > 3 ? 'top: 1.5rem;' : ''"
              @click.prevent.stop="showEditStationNameModal(station)"
            >
              <i class="fa fa-pencil"></i>
            </div>
            <p v-if="stationsList.length > 3"  style="margin-bottom: 0.1rem;" class="p-2">{{ station.name }}</p>
            <p v-if="stationsList.length > 3" class="bloc-target-lt">Objectif LT : <b>{{convertHourInDays(station.leadTimeTarget)}} </b></p>
            <p v-if="stationsList.length <= 3"> 
              <span class="p-2">{{ station.name }}</span> - &nbsp; <span class="bloc-target-lt"> Objectif LT : <b>{{convertHourInDays(station.leadTimeTarget)}} </b> </span>
            </p>
            <div
              class="workstation-kanbans-number">
              {{ station.kanbanCards.length }}
            </div>
          </div>
        </div>
        <div class="kanban-list" :class="!isUserThalesAdmin() ? 'large-screen' : ''">
          <div
            v-for="(kanbanCard, index) in station.kanbanCards"
            :key="index"
            @click="goToTracking(kanbanCard)"
            @contextmenu.prevent.stop="handleClick($event, kanbanCard)"
            class="kanban-card clickable"
            :class="
              kanbanCard.leadTime > parseFloat(station.leadTimeTarget)
                ? 'andon'
                : ''
            "
          >
            <div class="kanban-card-id">
              <div>{{ chunk(kanbanCard.code, 3) }} <span v-if="kanbanCard.code_gex !== '' && kanbanCard.code_gex !== null" class="styleGex">  - {{ chunk(kanbanCard.code_gex.substr(3, kanbanCard.code_gex.length -1), 6) }}</span></div>
              <div v-if="kanbanCard.sdcd" class="sdcd-pill"></div>
            </div>
            <span v-if="!checkEmpty(kanbanCard.andonData)" class="kanban-andon-duration">
              <img src="../assets/clock-regular.svg" alt="" />
              {{ convertHourInDays(kanbanCard.andonDuration /60)}} 
            </span>
            <div class="kanban-lead-time">
              {{ getTime(kanbanCard.leadTime * 60) }}
            </div>
          </div>
        </div>
      </div>
      <station-modal
        ref="station-modal"
        :title="getTitle()"
        :stationsList="stationsList"
        @station-modal-closed="emitCloseModal"
      />
      <scan-modal
        ref="scan-modal"
        @document-scan-modal-close="emitDocScanUpated"
        @cancel-modal="emitResetDisable"
      />
      <edit-document-modal
        ref="edit-document-modal"
        @edit-document-modal-close="emitDocEdition"
        @cancel-modal="emitResetDisable"
      />
      <edit-station-name-modal
        ref="edit-station-name-modal"
        @edit-station-name-modal-closed="emitCloseModal"
      />
    </div>
    <!-- context menu -->
    <vue-simple-context-menu
      :elementId="'context-menu-' + flux.name"
      :options="contextMenuList"
      :ref="'vueSimpleContextMenu'"
      @option-clicked="optionClicked"
    />
  </div>
</template>
<script>
import StationModal from './StationModal.vue'
import ScanModal from './ScanModal.vue'
import EditDocumentModal from './EditDocumentModal.vue'
import EditStationNameModal from './EditStationNameModal.vue'

import VueSimpleContextMenu from 'vue-simple-context-menu'
import printHeureServer from '../api/printHeureServer.vue'
import ZebraPrinter from '../core/services/ZebraPrinter.js'
import _ from 'lodash'

export default {
  name: 'StationsData',
  props: ['stationsList', 'flux'],
  components: {
    'station-modal': StationModal,
    'scan-modal': ScanModal,
    'edit-document-modal': EditDocumentModal,
    'edit-station-name-modal': EditStationNameModal,
    'vue-simple-context-menu': VueSimpleContextMenu,
  },
  data() {
    return {
      stationSelected: '',
      zebraPrinter : new ZebraPrinter(),
      contextMenuList: [
        {
        name: 'Imprimer l\'étiquette',
        slug: 'print',
        class: 'print',
        },
        {
        name: 'Editer le document',
        slug: 'edit',
        class: 'edit',
        },
        {
        name: 'Changer de station',
        slug: 'scan',
        class: 'scan',
        },
      ]
    }
  },
  methods: {
    printWithBrother (document) {
      const data = [{ CODE: document.code }]
      printHeureServer.printDocument(data).then(() => {
        this.$toasted.success("Etiquette imprimée!")
      }).catch((error) => {
        this.$toasted.error(`Erreur d'impression ! ${error}`)
      })
    },
    printWithZebra (document) {
      var cmds =  `^XA~TA000~JSN^LT0^MNW^MTT^PON"
      ^PMN^LH0,0^JMA^PR6,6~SD15^JUS
      ^LRN^CI27^PA0,1,1,0^XZ^XA^MMT^PW609^LL405
      ^LS0
      ^BY3,3,195^FT26,287^BCN,,Y,N^FH\^FD${document.code}^FS
      ^FT204,353^A0N,32,33^FH\^CI28^FD${document.description}^FS^CI27
      ^FT250,67^A0N,36,35^FH\^CI28^FD${this.flux.name}^FS^CI27^PQ1,0,1,Y^XZ`
      this.zebraPrinter.send(cmds).then((result) => {
        // this.documentPrinted = true
        this.$toasted.success("Etiquette imprimée!")
      }).catch((error) => {
        this.$toasted.error(`Impossible d'imprimer ...<br>Êtes-vous connecté à l'imprimante zebra ?`)
        console.log(error)
      })
    },
    sizeWorkstationCard(stationsList){
      if(stationsList.length <= 3){
        return "min-height: 65px";
      }
      else{
        return "min-height: 150px";  
      }
        
    },
    sizeWorkstationList(station){
      if(station.length <= 3){
        return "min-height : 250px;";
      }
      else{
        return "min-height : 350px ";
      }
    },
    printDocument (document) {
      if (!localStorage.getItem('printer_type')) {
        this.printWithBrother(document)
      } else if (localStorage.getItem('printer_type') === 'zebra' ||
        this.isUserThales())
      {
        this.printWithZebra(document)
      } else {
        this.printWithBrother(document)
      }
    },
    handleClick (event, item) {
      if (!item.disable) {
        this.$refs.vueSimpleContextMenu.showMenu(event, item)
      }
    },
    showEditDocumentModal(document) {
      this.$refs['edit-document-modal'].showModal(document)
    },
    showScanModal(document) {
      this.$refs['scan-modal'].showModal(document)
    },
    showEditStationNameModal (workstation) {
      this.$refs['edit-station-name-modal'].showModal(workstation)
    },
    optionClicked (event) {
      const option = event.option.slug
      const document = event.item
      if (option === 'print') {
        this.printDocument(document)
      } else if (option === 'scan') {
        document.disable = true
        this.showScanModal(document)
      } else if (option === 'edit') {
        document.disable = true
        this.showEditDocumentModal(document)
      }
    },
    goToTracking (kanban) {
      if (!kanban.disable) {
       this.goTo('/tracking_order/' + kanban.code)
      }
    },
    checkEmpty(array) {
      return _.isEmpty(array)
    },
    refresh () {
      this.$forceUpdate()
    },
    showStationModal(station) {
      this.stationSelected = station
      this.$refs['station-modal'].updateProps(station)
      this.$refs['station-modal'].showModal()
    },
    getStationSelected() {
      return this.stationSelected
    },
    getTitle() {
      let flux = this.flux.description.toUpperCase()
      return `${flux} - ${this.stationSelected.name}`
    },
    averageLeadTime(kanbanCards) {
      let avgLeadTime = 0
      let leadTimeList = kanbanCards.map(kanban => {
        return parseFloat(kanban.leadTime)
      })
      avgLeadTime =
        leadTimeList.reduce((acc, cur) => {
          return acc + cur
        }) / kanbanCards.length
      return avgLeadTime.toFixed(1)
    },
    emitCloseModal () {
      this.$emit('station-modal-closed')
    },
    emitDocScanUpated (scanInfo) {
      this.$emit('document-scan-modal-close', scanInfo)
    },
    emitDocEdition (edtionInfo) {
      this.$emit('edit-document-modal-close', edtionInfo)
    },
    emitResetDisable (code) {
      this.$emit('cancel-modal', code)
    },
    str_pad_left (string, pad, length) {
      return (new Array(length + 1).join(pad) + string).slice(-length)
    },

    convertHourInDays (timeInHour) {
      timeInHour = parseFloat(timeInHour/24).toFixed(1)
      if (timeInHour %1 == 0) {
        timeInHour = parseInt(timeInHour)
      }
      return timeInHour + ' j'
    },
    get_decimal_part (hours) {
      var day = 0.0
      day = (hours/24).toFixed(2)
      var dayDecimalTime = ''
      var finalDecimalTime = ''
      var index = 0
      dayDecimalTime = day.toString()
      day = dayDecimalTime.split('')
      index = day.indexOf('.')
      finalDecimalTime = day[index + 1]
      return finalDecimalTime
    },
    getTime (timeInMin) {
      timeInMin = Math.round(timeInMin)
      var finalTime = ''
      var hours = Math.floor(timeInMin / 60)
      timeInMin = timeInMin - hours * 60
      var minutes = timeInMin
      finalTime = Math.floor(hours/24) + '.' + this.get_decimal_part(hours) 
      if (finalTime %1 == 0) {
        finalTime = parseInt(finalTime)
      }
     /*  finalTime = hours + 'h' + this.str_pad_left(minutes, '0', 1)
      if (hours > 48) {
        finalTime = Math.round(hours/24) + 'j'
      }
      else {
        finalTime = hours + 'h' + this.str_pad_left(minutes, '0', 2)
      }  */
      return finalTime + ' j'
    },
    computeLeadTime (station) {
      if (_.isEmpty(station.kanbanCards)) {
        station.leadTime = 0
      } else if (station.kanbanCards.length == 1) {
        station.leadTime = parseFloat(station.kanbanCards[0].leadTime).toFixed(
          2
        )
      } else {
        station.leadTime = this.averageLeadTime(station.kanbanCards)
      }
      return this.getTime(station.leadTime * 60)
    }
  },
  beforeMount: function () {
  },
  /* mounted() {
   this.stationsList.forEach(station => {
      console.log(station)
    });
  }, */
  watch: {
  },
  
}
</script>
<style>
.kanban-list {
  height: 120px;
  overflow-y: auto;
}

.workstation-list .workstation-card .bloc-target-lt{
  font-size: 16px;
}

@media screen and (min-width: 1919px) {  
  .workstation-list .workstation-card .bloc-target-lt {
     /*  font-size: 1.8rem; */
      font-weight: 900;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StationsData.vue